/* Designposters – Frame selector */
(function () {
  var TAG = '[frame-selector]';

  function initAll() {
    document.querySelectorAll('.dp-frame-selector:not([data-dp-init])').forEach(init);
  }

  function init(root) {
    root.setAttribute('data-dp-init', '1');

    var data;
    try {
      data = JSON.parse(root.querySelector('[data-dp-frames]').textContent);
    } catch (e) {
      console.error(TAG, 'JSON parse failed:', e);
      return;
    }

    var CART_FRAME = data.cartFrame || 'Frame';
    var CART_FRAME_FOR = data.cartFrameFor || 'Frame for';

    var section = root.closest('.shopify-section') || document;
    var form =
      section.querySelector('product-form-component form') ||
      section.querySelector('form[action*="/cart/add"]');

    var selected = null;
    var overlay = null;
    var propInput = null;

    /* ---------- poster line property ---------- */
    function posterPropName() {
      return 'properties[' + CART_FRAME + ']';
    }
    function setPosterProperty() {
      if (!form) return;
      if (selected) {
        if (!propInput || !propInput.isConnected) {
          propInput = form.querySelector('input[name="' + posterPropName() + '"]');
          if (!propInput) {
            propInput = document.createElement('input');
            propInput.type = 'hidden';
            propInput.name = posterPropName();
            form.appendChild(propInput);
          }
        }
        propInput.value = selected.label;
      } else if (propInput && propInput.isConnected) {
        propInput.remove();
        propInput = null;
      }
    }

    /* ---------- overlay on the first VISIBLE product image ---------- */
    function isVisible(el) {
      if (!el) return false;
      var r = el.getBoundingClientRect();
      return r.width >= 40 && r.height >= 40;
    }
    function getFirstMediaImg() {
      var gallery = section.querySelector('media-gallery');
      if (!gallery) return null;
      var candidates = [];
      var grid = gallery.querySelector('.media-gallery__grid');
      if (grid) {
        var li = grid.querySelector(':scope > .product-media-container');
        if (li) candidates.push(li);
      }
      var firstSlide = gallery.querySelector('slideshow-slide');
      if (firstSlide) candidates.push(firstSlide);
      for (var i = 0; i < candidates.length; i++) {
        if (isVisible(candidates[i])) {
          var im = candidates[i].querySelector('img');
          if (im) return im;
        }
      }
      var imgs = gallery.querySelectorAll('img');
      for (var j = 0; j < imgs.length; j++) {
        if (imgs[j].closest('.slideshow-controls, .dialog-thumbnails-list, zoom-dialog, .dialog-zoomed-gallery')) continue;
        if (isVisible(imgs[j])) return imgs[j];
      }
      return null;
    }
    function ensureOverlay() {
      var img = getFirstMediaImg();
      if (!img) return;
      var host = img.parentElement;
      if (!host) return;
      if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
      if (!overlay) {
        overlay = document.createElement('img');
        overlay.className = 'dp-frame-overlay';
        overlay.alt = '';
        overlay.setAttribute('aria-hidden', 'true');
        overlay.decoding = 'async';
      }
      if (overlay.parentElement !== host) host.appendChild(overlay);
      reposition(img, host);
      applyOverlay();
    }
    function reposition(img, host) {
      if (!overlay) return;
      img = img || getFirstMediaImg();
      if (!img) return;
      host = host || overlay.parentElement;
      if (!host) return;
      var ir = img.getBoundingClientRect();
      var hr = host.getBoundingClientRect();
      overlay.style.position = 'absolute';
      overlay.style.left = ir.left - hr.left + 'px';
      overlay.style.top = ir.top - hr.top + 'px';
      overlay.style.width = ir.width + 'px';
      overlay.style.height = ir.height + 'px';
      overlay.style.pointerEvents = 'none';
      overlay.style.zIndex = '3';
      overlay.style.transition = 'opacity .25s ease';
      overlay.style.backgroundColor = 'transparent';
    }
    function applyOverlay() {
      if (!overlay) return;
      if (selected) {
        var url = data.orientation === 'landscape' ? selected.overlayLandscape : selected.overlayPortrait;
        if (url) {
          overlay.src = url;
          overlay.style.opacity = '1';
          return;
        }
      }
      overlay.style.opacity = '0';
    }

    /* ---------- size -> frame variant ---------- */
    function currentPosterVariantId() {
      var input = form && form.querySelector('input[name="id"]');
      return input ? input.value : null;
    }
    function currentSizeKey() {
      var id = currentPosterVariantId();
      if (id && data.poster.variants[id]) return data.poster.variants[id];
      return null;
    }
    function frameVariantForSelected() {
      if (!selected) return null;
      var size = currentSizeKey();
      if (size && selected.variants[size]) return selected.variants[size];
      return null;
    }

    function updateLabel() {
      var nameEl = root.querySelector('[data-dp-selected-name]');
      var priceEl = root.querySelector('[data-dp-selected-price]');
      if (selected) {
        if (nameEl) nameEl.textContent = selected.label;
        var fv = frameVariantForSelected();
        if (priceEl) priceEl.textContent = fv ? '+ ' + fv.price : '';
      } else {
        if (nameEl) nameEl.textContent = data.noFrameLabel;
        if (priceEl) priceEl.textContent = '';
      }
    }

    function selectFrame(frame, btn) {
      selected = frame || null;
      root.querySelectorAll('.dp-fs__swatch').forEach(function (b) {
        b.classList.remove('is-selected');
        b.setAttribute('aria-pressed', 'false');
      });
      if (btn) {
        btn.classList.add('is-selected');
        btn.setAttribute('aria-pressed', 'true');
      }
      setPosterProperty();
      ensureOverlay();
      updateLabel();
    }

    root.querySelectorAll('.dp-fs__swatch').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var h = btn.getAttribute('data-frame-handle');
        if (!h) return selectFrame(null, btn);
        var f = data.frames.find(function (x) { return x.handle === h; });
        selectFrame(f || null, btn);
      });
    });

    if (form) {
      section.addEventListener('change', function () { setTimeout(updateLabel, 60); });
      var idInput = form.querySelector('input[name="id"]');
      if (idInput && 'MutationObserver' in window) {
        new MutationObserver(updateLabel).observe(idInput, { attributes: true, attributeFilter: ['value'] });
      }
    }

    /* ---------- cart helpers ---------- */
    function addUrl() {
      return ((window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add') + '.js';
    }
    function getQty() {
      try { return parseInt(new FormData(form).get('quantity') || '1', 10) || 1; } catch (e) { return 1; }
    }
    function addFrame(frameId, qty) {
      var props = {};
      props[CART_FRAME_FOR] = data.poster.title;
      return fetch(addUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(frameId), quantity: qty, properties: props }] })
      }).then(function (r) { return r.json(); });
    }
    function refreshDrawer() {
      var ci = document.querySelector('cart-items-component');
      var sid = ci && ci.dataset ? ci.dataset.sectionId : null;
      if (!sid) return;
      fetch(window.location.pathname + '?section_id=' + encodeURIComponent(sid), { headers: { Accept: 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var wrapper = document.getElementById('shopify-section-' + sid);
          if (wrapper && html) wrapper.innerHTML = html;
        })
        .catch(function () {});
    }

    /* ---------- primary path: frame first, then let the theme add the poster ---------- */
    if (form) {
      form.addEventListener(
        'click',
        function (e) {
          if (!selected) return;
          var t = e.target;
          var btn = t && t.closest ? t.closest('[ref="addToCartButton"], .add-to-cart-button, button[name="add"], button[type="submit"]') : null;
          if (!btn) return;
          if (btn.closest('.shopify-payment-button, accelerated-checkout-component')) return;
          if (form.__dpAdding) return;
          var fv = frameVariantForSelected();
          if (!fv) return;
          e.preventDefault();
          e.stopImmediatePropagation();
          form.__dpAdding = true;
          var qty = getQty();
          addFrame(fv.id, qty)
            .catch(function () {})
            .finally(function () {
              if (form.requestSubmit) form.requestSubmit();
              else form.submit();
              setTimeout(function () { form.__dpAdding = false; }, 0);
            });
        },
        true
      );

      form.addEventListener(
        'submit',
        function () {
          if (!selected) return;
          if (form.__dpAdding) return;
          var fv = frameVariantForSelected();
          if (!fv) return;
          form.__dpAdding = true;
          setTimeout(function () {
            addFrame(fv.id, getQty())
              .catch(function () {})
              .finally(function () {
                refreshDrawer();
                setTimeout(function () { form.__dpAdding = false; }, 0);
              });
          }, 250);
        },
        true
      );
    }

    /* ---------- boot + keep overlay aligned ---------- */
    ensureOverlay();
    updateLabel();
    var relayout = function () { ensureOverlay(); };
    window.addEventListener('resize', relayout, { passive: true });
    window.addEventListener('scroll', function () { if (overlay && overlay.style.opacity === '1') reposition(); }, { passive: true });
    if ('MutationObserver' in window) {
      new MutationObserver(function () { ensureOverlay(); }).observe(section, { childList: true, subtree: true });
    }
    [200, 600, 1200, 2000].forEach(function (t) { setTimeout(relayout, t); });
    section.querySelectorAll('media-gallery img').forEach(function (im) { im.addEventListener('load', relayout); });
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
